module.exports = __webpack_public_path__ + "media/נחליאלי.4f899bc3.mp3";